/* eslint no-shadow: "off", no-param-reassign: ["error", { "props": false }], no-console: "off", quotes: "off" */
import axios from 'axios';
import auth from "../../../common/auth";

export default {
  getLocaleAndTranslations({ dispatch, commit }) {
    return dispatch('getAvailableLocalesFromBackend')
      .then(() => dispatch('defaultLanguageFromProperty'))
      .then(() => dispatch('getTranslationsFile'))
      .then(() => commit('changeCSSFile'));
  },
  methodTochangeLocales({ dispatch, commit }, payload) {
    localStorage.setItem('locale', payload.currentLocale.toUpperCase());
    commit('updateLocaleFromLocalStorage');
    console.log(`state.currentLocale in  methodTochangeLocales action: ${localStorage.getItem('locale')}`);
    return dispatch('getTranslationsFile')
      .then(() => commit('changeCSSFile'))
      .then(() => dispatch('profile/storeAvailablePrizeTypes', localStorage.getItem('locale'), { root: true }))
      .then(() => dispatch('profile/storeAvailablePrizeTypesPerGame', localStorage.getItem('locale'), { root: true }));
  },
  defaultLanguageFromProperty({ commit }) {
    console.log('[API CALL] - Fetching default Language from properties');
    return axios.get('api/getDefaultLanguage').then((response) => {
      commit({ type: 'storeDefaultLanguage', defaultLanguage: response.data });
    }).catch(error => console.log(error));
  },
  getAvailableLocalesFromBackend({ state, commit }) {
    console.log("Fetching available locales");
    return axios.get('api/getAvailableLocales')
      .then((response) => {
        commit('setAvailableLocales', { availableLocales: response.data });
        const numberOfLocales = Object.keys(state.availableLocales).length;
        commit('setSettingsPageLocales', { settingsPageLocales: new Array(numberOfLocales) });
        for (let i = 0; i < state.settingsPageLocales.length; i += 1) {
          state.settingsPageLocales[i] = { isActive: false };
        }
        let i = -1;
        // eslint-disable-next-line
        for (const key in state.availableLocales) {
          // eslint-disable-next-line
          if (state.availableLocales.hasOwnProperty(key)) {
            state.localesMappedWithIndices[key] = [i += 1, state.availableLocales[key]];
            if (key === state.currentLocale) {
              state.settingsPageLocales[i].isActive = true;
            }
          }
        }
        commit('updateLocaleFromLocalStorage');
      })
      .catch((error) => {
        console.log(`Invoking api/getAvailableLocales failed with the following error: ${error}`);
      });
  },
  getTranslationsFile({ commit, state }) {
    console.log("Fetching Translations");
    console.log(`[API CALL] - Invoking api/getTranslations?lang=${state.currentLocale}`);
    return axios.get(`api/getTranslations?lang=${state.currentLocale}`)
      .then((response) => {
        const data = response.data;
        const objectifiedData = data.reduce((o, key) => Object.assign(o, { [key[0]]: key[1] }), {});
        commit({ type: 'setFaviconURL', faviconURL: objectifiedData.project_config_index_favicon_img });
        commit({ type: 'storeTranslations', translations: objectifiedData });
        commit({ type: 'setDocumentTitle', text: objectifiedData.project_config_index_document_title });
        commit({ type: 'setDescription', text: objectifiedData.project_config_index_description_content });
        commit({ type: 'setKeywords', text: objectifiedData.project_config_index_keywords_content });
        commit({ type: 'setDefaultImage', text: objectifiedData.fb_share_store_img });
        commit('profile/setVisitorCarouselPrize', objectifiedData, { root: true });
        console.log(`state current Locale' ${state.currentLocale}`);
        console.log(`state faviconURL' ${state.faviconURL}`);
      })
      .catch((error) => {
        console.log(`Invoking api/getTranslations failed with the following error: ${error}`);
      });
  },
  updateUserLanguage({ state }) {
    return axios({
      url: `api/updateLanguage?lang=${state.currentLocale}`,
      method: 'POST',
      headers: {
        Authorization: auth.getJwt(),
      },
      data: {
        language: state.currentLocale,
      },
    }).catch((error) => {
      console.log(`Invoking api/updateLanguage failed with the following error: ${error}`);
    });
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/i18n/actions.js